export const QUANTITY_DECIMAL_PLACES = 5
export const NUMERIC_FORMAT = '0,0.00[000]'
export const NUMERIC_INPUT_FORMAT = '0,0.[00000]'

export const DATE_FORMAT = "M/D/YYYY"
export const DATETIME_FORMAT = "M/D/YYYY HH:mm:ss"

export const ComponentConfig = {
    DatePicker: {
        format: DATE_FORMAT
    },
    Select: {
        triggerProps: {
            autoAlignPopupWidth: false,
            autoAlignPopupMinWidth: true,
            position: 'bl',
        },
        filterOption: (inputValue, option) => {
            return option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
        }
    },
    Table: {
        pagination: {
            pageSize: 20
        }
    },
    Form: {
        validateMessages: {
            required: (_, { label }) => label ? `${label} is required` : "field is required"
        }
    }
}
